import React from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export const SectionThree = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });


  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });


  const withOutKEData = [
    {
      headline: "95% of your web traffic is anonymous",
    },
    {
      headline: "90% cart abandoners don't come back",
    },
    {
      headline: "WhatsApp/Email/SMS are used but not optimized",
    },
    {
      headline: "No real-time engagement = no conversion",
    },
  ];




  const withKEData = [
    {
      headline: "Identify up to 25% anonymous visitors instantly with KwikPass",
    },
    {
      headline: "Recover up to 20–25% carts with smart, personalized nudges",
    },
    {
      headline: "Run end-to-end personalized marketing and support for D2C on WhatsApp,& Email & Instagram",
    },
    {
      headline: "Trigger real-time conversations based on site behaviour & intent, while they're still active",
    },
  ];


  return (
    <div className="section-3a-Ind">
      <div >
        <div className="testimonial-content-Ind">
          <div className="testimonial-text-Ind">Your current retargeting campaigns <br /> are leaking revenues upto 30%</div>

        </div>

        <div className="flex  gap-5" style={{margin:isMobile?"0 0":"0 185px",flexDirection:isMobile?"column":"row"}}>
          <div className="withoutke" style={{height:isMobile ? "auto":'470px',width:"100%"}}>
            <div>
              <h1>Without KwikEngage</h1>
              {
                withOutKEData.map((text, idx) => (  
                  <p key={idx} className="mt-3 second">
                    <img
                      src="/assets/images/keindia/cross.png"
                      alt=""
                    />
                    <span className="mx-2">{text.headline}</span>
                  </p>
                ))}
            </div>
          </div>
          <div className="withkeouter" style={{width:"100%"}}>
            <div className="withke" >
              <div >
                <h1>With KwikEngage</h1>
                {
                  withKEData.map((text, idx) => (
                    <p key={idx} className="mt-3 second">
                      <img
                        src="/assets/images/keinternational/check.png"
                        alt=""
                      />
                      <span className="mx-2">{text.headline}</span>
                    </p>
                  ))}
              </div>
            </div>
            <div className="demobtn">
              <h4 style={{fontWeight:"400"}}>Want this for your brand?</h4>

              <button onClick={scrollToTop} className="cta2-Ind flex items-center gap-2">
                Book a Demo

              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
